import { Injectable } from "@angular/core";
import {
  getCurrentSoftwareProduct,
  SoftwareProduct
} from "src/app/support/product";

@Injectable()
export class ProductService {
  getCurrentProduct(): SoftwareProduct {
    return getCurrentSoftwareProduct();
  }
}
